import StateStoreBase from './state.store.base';

class StateStore extends StateStoreBase {
  constructor() {
    super({ name: 'state-store' });
  }
}

export default new StateStore();
